/**
 * AutoMoveStatus.jsx - Shows auto-movement queue status
 */

import React from 'react';

export function AutoMoveStatus({
  isAutoMoving,
  movementQueue,
  onCancel
}) {
  if (!isAutoMoving || movementQueue.length === 0) {
    return null;
  }

  return (
    <div className="wm-auto-move">
      <div className="wm-auto-move-status">
        <span className="wm-auto-icon">🛤️</span>
        <span className="wm-auto-text">
          Auto: {movementQueue.length} step{movementQueue.length !== 1 ? 's' : ''}
        </span>
      </div>
      <button className="wm-auto-cancel" onClick={onCancel}>x</button>
    </div>
  );
}

export default AutoMoveStatus;
